import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { DivisionService } from 'src/app/services/division.service';

@Component({
  selector: 'app-villagelevelpopup',
  templateUrl: './villagelevelpopup.component.html',
  styleUrls: ['./villagelevelpopup.component.scss']
})
export class VillagelevelpopupComponent implements OnInit {
  schemaId: any;
  financial: any;
  goid: any;
  scheme: any;
  component: any;
  product: any;
  financialYear: any;
  division: any;
  divisionId: any;
  subdivisionId: any;
  subdivision: any;
  result: any;
  goidcode: any;
  componentcode: any;
  productcode: any;
  statetargetlist: any[];
  totalList: { bold: number; communityTypeName: string; genderTypeName: string; subsidyAmount: number; totalMachinery: number; }[];

  constructor(
    public dialogRef: MatDialogRef<VillagelevelpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public addServiceDialog: MatDialog,
    private divisionService: DivisionService,
  ) {
    this.financial = this.dataRecievedData.financialyear,   
    this.financialYear = this.dataRecievedData.financialyearcode,


      this.goid = this.dataRecievedData.goid,
      this.goidcode = this.dataRecievedData.goidcode,

      this.scheme = this.dataRecievedData.scheme,
      this.schemaId = this.dataRecievedData.schemecode,

      this.component = this.dataRecievedData.component,
      this.componentcode = this.dataRecievedData.componentcode,

      
      this.product = this.dataRecievedData.product,
      this.productcode = this.dataRecievedData.productcode,


      this.division = this.dataRecievedData.division,
      this.divisionId = this.dataRecievedData.divisioncode,
      
      this.subdivisionId = this.dataRecievedData.subdivisioncode,
      this.subdivision = this.dataRecievedData.subdivision
  }



  ngOnInit(): void {
    this.village();
    this.villagepopup();
  }
  cancel() {
    this.dialogRef.close();
  }
  village() {
    //departmentneed
    this.divisionService.getdbtstatetargetmapping(true, this.financialYear,1, this.goidcode, this.schemaId, this.componentcode).subscribe(res => {
      this.result = res;
    })
  }
  villagepopup() {
    this.divisionService.village(this.financialYear, this.goidcode, this.schemaId, this.componentcode, this.productcode,this.subdivisionId, true).subscribe(res => {
      this.statetargetlist = [];
      this.statetargetlist = res;
      this.totalList = [{
        bold:1,
        communityTypeName: "Total",
        genderTypeName: "",
        subsidyAmount: _.sumBy(res, 'subsidyAmount'),
        totalMachinery: _.sumBy(res, 'totalMachinery')
      }]

      if (res.length > 0) {
        this.statetargetlist.push(this.totalList[0]);
      }
      this.statetargetlist = res;

    })
  }
}
